//MINOR DIFFERENCES - seems to all be asthetic differences 

import { Theme, Typography, useTheme } from "@mui/material";
import { useState } from "react";

import Accordian from "./accordian";
import ListSlide from "./listSlide";
import NoListImgSlide from "./noListImgSlide";
import IdentitySliderSlide from "./slideContainer";
import SlideHeading from "./slideHeader";
import { Slider, SliderWrapper } from "./slider";

import Bad from "@mui/icons-material/CancelOutlined";
import CheckBox from "@mui/icons-material/CheckBox";
import useText from "../../../hooks/useText";

const margin = {
    m: (theme: Theme) => theme.spacing(2, 0),
};

const IdentitySlider = ({
    identity,
    identityKey,
    identityRank,
    whoAreThey,
    characteristics,
    thrive,
    value,
    blind,
}: {
    identity: string;
    identityKey: string;
    identityRank: number;
    whoAreThey: string[];
    characteristics: string[];
    thrive: string[];
    value: any;
    blind: any;
}) => {
    const [tab, setTab] = useState(0);
    const text = useText()?.identitySlider.index;
    const sections = text.sections;
    const theme = useTheme();
    // @ts-expect-error
    const identityColors = theme.palette.mojoColors.identities[identityKey];
    const imgUrl = `/images/Icon${identityColors.image}.png`;
    const color = identityColors.dark;
    if (!whoAreThey) return null;
    return (
        <>
            <Slider sections={sections} tab={tab} setTab={setTab} color={color} />
            <IdentitySliderSlide
                identityKey={identityKey}
                identity={identity}
                identityRank={identityRank}
            >
                <SliderWrapper isVisible={tab === 0}>
                    <NoListImgSlide color={color} identity={identity} imgUrl={imgUrl}>
                        <SlideHeading sx={margin} color={color}>
                            {sections[0]}
                        </SlideHeading>
                        {whoAreThey.map((text) => (
                            <Typography key={text} sx={margin} variant="body1">
                                {text}
                            </Typography>
                        ))}
                    </NoListImgSlide>
                    <SlideHeading sx={margin} color={color}>
                        {text.characteristics}
                    </SlideHeading>
                    <Accordian panels={characteristics} />
                </SliderWrapper>
                <SliderWrapper isVisible={tab === 1}>
                    <NoListImgSlide color={color} identity={identity} imgUrl={imgUrl}>
                        <SlideHeading sx={margin} color={color}>
                            {sections[1]}
                        </SlideHeading>
                        {thrive.map((text) => (
                            <Typography key={text} sx={margin} variant="body1">
                                {text}
                            </Typography>
                        ))}
                    </NoListImgSlide>
                </SliderWrapper>
                <SliderWrapper isVisible={tab === 2}>
                    <ListSlide
                        header={sections[2]}
                        imgUrl={imgUrl}
                        color={color}
                        sx={margin}
                        listIcon={<CheckBox />}
                        {...value}
                    />
                </SliderWrapper>
                <SliderWrapper isVisible={tab === 3}>
                    <ListSlide
                        header={sections[2]}
                        imgUrl={imgUrl}
                        color={color}
                        sx={margin}
                        listIcon={<Bad />}
                        {...blind}
                    />
                </SliderWrapper>
            </IdentitySliderSlide>
        </>
    );
};

export default IdentitySlider;